import { cx } from "@app/shared/utils/cx";
import styles from "./Avatar.module.css";

export type AvatarSize = "sm" | "md" | "lg";

export type AvatarProps = {
  name: string;
  src?: string | null;
  size?: AvatarSize;
  className?: string;
};

const initialsFrom = (name: string) =>
  name
    .trim()
    .split(/\s+/)
    .slice(0, 2)
    .map((part) => part[0]?.toUpperCase() ?? "")
    .join("");

export const Avatar = ({ name, src, size = "md", className }: AvatarProps) => (
  <span className={cx(styles.avatar, styles[size], className)}>
    {src ? <img className={styles.image} src={src} alt={name} /> : initialsFrom(name)}
  </span>
);
